import { Icon as MDIcon } from '@mdi/react';

type IconProps = {
    icono: string;
    size?: number;
    className?: string;
    color?: string;
};

export default function Icon({ icono, size, color, className }: IconProps) {
    let icon = undefined;
    try {
        icon = require(`materialdesign-js/icons/${icono}`).default;
    } catch (e) {
        icon = undefined;
    }

    if (!icon) {
        return <h6>No encontrado</h6>;
    }
    return <MDIcon path={icon} size={size ? size : 1} className={className} color={color} />;
}
